import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import saveAs from 'file-saver';
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import OrdemProducao from "model/producao/OrdemProducao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import OrdemProducaoService from "service/producao/OrdemProducaoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData, converterDataHora } from "utils/convert";
import { IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, booleanFilterTemplate, dateRangeFilterTemplate, decimalFilterTemplate, filterApplyTemplate, numberFilterTemplate, statusFilterTemplate } from "utils/filterUtils";

const ordemProducaoService = new OrdemProducaoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function OrdemProducaoListagem() {

    const [queryParameters] = useSearchParams();

    const { msgErro } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [titulo, setTitulo] = useState<string>('Ordens de Produção');

    const [produtosDisponiveis, setProdutosDisponiveis] = useState<Produto[]>([]);

    const [clientes, setClientes] = useState<Pessoa[]>([]);

    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [editaRelatorioSimplificado, setEditaRelatorioSimplificado] = useState<boolean>(false);
    const [editaRelatorioCertificadoAnalise, setEditaRelatorioCertificadoAnalise] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);



    useEffect(() => {
        ordemProducaoService.getProdutosProduzidos().then(lista => {
            setProdutosDisponiveis(lista);
        }).catch(err => {
            console.log(err);
        });
        ordemProducaoService.getClientes().then(lista => {
            setClientes(lista);
        }).catch(err => {
            console.log(err);
        });
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setEditaRelatorio(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_PRODUCAO"));
            setEditaRelatorioSimplificado(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_PRODUCAO_SIMPLIFICADO"))
            setEditaRelatorioCertificadoAnalise(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_OP_CERTIFICADO_ANALISE"))
        }).catch((erro) => {
            console.log(erro);
        });
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        numeroPedido: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidadePrevista: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidadeProduzida: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: [],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataFim: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        lote: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        reprovado: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const clienteFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={clientes}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const botoesExtra = () => {
        const model = [
            { label: "Simplificado", icon: "pi pi-file-pdf", command: () => getRelatorioSimplificado() },
        ];
        if (editaRelatorio || editaRelatorioSimplificado || editaRelatorioCertificadoAnalise) {
            model.push({ label: "Editar relatórios", icon: "pi pi-pencil", command: () => setVisibleEditarRelatorio(true) });
        }
        const botaoRelatorio = <SplitButton
            key="btn2"
            label="Relatório"
            onClick={() => getRelatorio()}
            icon="pi pi-file-pdf"
            model={model}
        />


        return [
            botaoRelatorio
        ]
    }

    const getRelatorio = () => {
        startLoading();
        ordemProducaoService.getRelatorio(filters).then((response) => {
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, getNomeRelatorio() + ".pdf");
        }).catch((err) => {
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        }).finally(() => {
            stopLoading();
        });
    }

    const getRelatorioSimplificado = () => {
        startLoading();
        ordemProducaoService.getRelatorioSimplificado(filters).then((response) => {
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "(simpl.) " + getNomeRelatorio() + ".pdf");
        }).catch((err) => {
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        }).finally(() => {
            stopLoading();
        });
    }

    const getRelatorioCertificadoAnalise = (op: OrdemProducao) => {
        startLoading();
        ordemProducaoService.getRelatorioCertificadoAnalise(op.id).then((response) => {
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "Certificado de Análise - OP " + op.numero + ".pdf");
        }).catch((err) => {
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        }).finally(() => {
            stopLoading();
        });
    }

    function getNomeRelatorio() {
        if (filters.produto) {
            let produtoFilter = filters.produto as DataTableOperatorFilterMetaData
            if (produtoFilter.constraints[0] && produtoFilter.constraints[0].value) {
                return "OPs de " + produtoFilter.constraints[0].value;
            }
        }
        if (filters.status) {
            let statusFilter = filters.status as DataTableOperatorFilterMetaData
            if (statusFilter.constraints[0] && statusFilter.constraints[0].value) {
                return "OPs " + statusFilter.constraints[0].value.map((status: string) => ordemProducaoService.getStatusFilter(status)).join(", ");
            }
        }
        if (filters.dataGeracao) {
            let dataFilter = filters.dataGeracao as DataTableOperatorFilterMetaData
            if (dataFilter.constraints[0] && dataFilter.constraints[0].value && dataFilter.constraints[0].value.inicio) {
                return "OPs depois de " + converterData(dataFilter.constraints[0].value.inicio);
            }
            if (dataFilter.constraints[0] && dataFilter.constraints[0].value && dataFilter.constraints[0].value.fim) {
                return "OPs antes de " + converterData(dataFilter.constraints[0].value.fim);
            }
            if (dataFilter.constraints[0] && dataFilter.constraints[0].value && dataFilter.constraints[0].value.inicio && dataFilter.constraints[0].value.fim) {
                return "OPs entre " + converterData(dataFilter.constraints[0].value.inicio) + " e " + converterDataHora(dataFilter.constraints[0].value.fim);
            }
        }
        return "Ops";
    }



    const dialogEditarRelatorio = (
        <Dialog header="Editar relatório" visible={visibleEditarRelatorio} onHide={() => setVisibleEditarRelatorio(false)} >
            {editaRelatorio ? <ReportEdit nomeAcao="RELATORIO_PRODUCAO" titulo="Relatório de OPs" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
            {editaRelatorioSimplificado ? <ReportEdit nomeAcao="RELATORIO_PRODUCAO_SIMPLIFICADO" titulo="Relatório de OPs Simplificado" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
            {editaRelatorioCertificadoAnalise ? <ReportEdit nomeAcao="RELATORIO_OP_CERTIFICADO_ANALISE" titulo="Relatório de Certificado de Análise" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
        </Dialog>
    )

    return (
        <>
            {dialogEditarRelatorio}

            <BaseListagem
                buttonsExtra={botoesExtra()}
                ordenacao="numero,DESC" service={ordemProducaoService} urlService="/ordemProducao"
                tituloPagina={titulo} showRemoveButton={false} showNewButton={false}
                defaultFilters={defaultFilters} showClearFilterButton nome="ordemProducao"
                onChangeFilters={(filters) => setFilters(filters)}
            >

                <Column field="numero" header="Núm." filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="produto.nome" header="Produto" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtosDisponiveis} />} />
                <Column field="lote" header="Lote" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="lote"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="qtPrevista" header="Qtd. Prevista" filter filterField="quantidadePrevista" showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="qtProduzida" header="Qtd. Produida" filter filterField="quantidadeProduzida" showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="status" header="Status" body={(rowData) => ordemProducaoService.getStatus(rowData.status)} filter showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, ordemProducaoService.getListaStatusFilter())} />
                <Column field="dataGeracao" header="Data Geração" body={(rowData) => converterDataHora(rowData.dataGeracao)} filter showFilterOperator={false} showAddButton={false} filterElement={dateRangeFilterTemplate}
                    showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="dataFim" header="Data Finalização" body={(rowData) => converterDataHora(rowData.dataFim)} filter showFilterOperator={false} showAddButton={false} filterElement={dateRangeFilterTemplate}
                    showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="reprovado" header="Reprovada" body={(rowData) => <Checkbox checked={rowData.reprovado} readOnly />} style={{ width: '5em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={booleanFilterTemplate} />
                <Column body={(rowData) => {
                    return <Button label="Cert. Análise" icon="pi pi-file-pdf" onClick={() => {
                        getRelatorioCertificadoAnalise(rowData);
                    }} />
                }} header="Relatórios" />
            </BaseListagem>

        </>


    )
}